// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  //      For QA   Env
  //------------------------------------------------------------
  urlResponsive: "http://santovqaplw.tovpil.org/#/", // DEV URL WEB SITE
  urlApi: "https://santov.tovpil.org/tovapisQA/api/",
  cookieDomain: ".tovpil.org", // PROD 
  cookiePath: "/",

  //-------------------------------------------------------------
  //         Direct IPs
  //urlApi: "http://192.168.100.146:8090/api/",
  //urlApi: "http://143.110.138.93:8090/api/", 
  //-------------------------------------------------------------
  //    For LOCAL ENV
  // urlResponsive: "http://localhost:4200//#/", // DEV URL WEB SITE
  // urlApi: "http://localhost:8090/api/",
  // cookieDomain: undefined, // LOCAL
  // cookiePath: "/", // LOCAL
  //--------------------------------------------------------------
  menuTheme: "green",
  firebaseConfig: {
    apiKey: "AIzaSyDKJsSlqwBytr-v6qEuvk-pV32JQ1SBMRQ",
    authDomain: "santov-bfd44.firebaseapp.com",
    databaseURL: "https://santov-bfd44.firebaseio.com",
    projectId: "santov-bfd44",
    storageBucket: "santov-bfd44.firebasestorage.app",
    messagingSenderId: "105024133485",
    appId: "1:105024133485:web:0bbdc96be0e98d71e72264",
    measurementId: "G-LSNXNDC6JZ"
  }
};
